import React, { Component } from "react"
import { Helmet } from "react-helmet"

import { Flex, Box } from "grid-styled"
import { ImgScaled, TitleBlock } from "../styled-components"

import bilder from "../bilder/impressionen"

class Reportage extends Component {
  renderImages = (start = 1, end = bilder.length - 1) => {
    let images = []

    for (let i = start; i <= end; i++) {
      images.push(
        <Box width={1} key={i}>
          <ImgScaled
            data-sizes="100vw"
            srcSet={bilder[i].min}
            // src={bilder[i].max}
            data-srcset={bilder[i].srcset}
            className="lazyload blur-up"
            alt={"Bild " + i}
          />
        </Box>
      )
    }
    return images
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>Fotografie Anders: Impressionen</title>
        </Helmet>
        <Flex flexDirection="column" alignItems="center">
          <TitleBlock>
            Trockene Angelegenheit – in der Wüste der Vereinigten Arabischen
            Emirate
          </TitleBlock>
          {this.renderImages(1, 5)}
        </Flex>
        <Flex flexDirection="column" alignItems="center">
          <TitleBlock>Randgebiet – unterwegs in Jakarta</TitleBlock>
          {this.renderImages(6, 13)}
        </Flex>
        <Flex flexDirection="column" alignItems="center">
          <TitleBlock>
            Nah am Wasser gebaut – an den Grachten von Amsterdam
          </TitleBlock>
          {this.renderImages(14, 16)}
        </Flex>
        <Flex flexDirection="column" alignItems="center">
          <TitleBlock>Ahornköpfe – Menschen an der Ostküste Kanadas</TitleBlock>
          {this.renderImages(17, 20)}
        </Flex>
        <Flex flexDirection="column" alignItems="center">
          <TitleBlock>
            Shine bright like a diamond! – Glitzermetropole Dubai
          </TitleBlock>
          {this.renderImages(21, 27)}
        </Flex>
        <Flex flexDirection="column" alignItems="center">
          <TitleBlock>Ruhepuls – Rummel und Atempause in Shanghai</TitleBlock>
          {this.renderImages(28, 30)}
        </Flex>
        <Flex flexDirection="column" alignItems="center">
          <TitleBlock>
            Volldampf! – Leben am Bromo Vulkan in Indonesien
          </TitleBlock>
          {this.renderImages(31, 35)}
        </Flex>
        <Flex flexDirection="column" alignItems="center">
          <TitleBlock>
            Spiel mit dem Feuer – traditioneller Ketschack-Tanz auf Bali
          </TitleBlock>
          {this.renderImages(36, 38)}
        </Flex>
      </div>
    )
  }
}

export default Reportage



// WEBPACK FOOTER //
// ./src/pages/Impressionen.js